import Uri from 'goog:goog.Uri';

import yext from 'goog:yext';

import {googleOAuthInit, onGithubOAuth} from '/src/com/yext/platform/users/js/common/oauthbuttons';

document.addEventListener('DOMContentLoaded', function() {
  $('.js-users-init').each(function(index) {
    var initIdentifier = $(this).data('jsinit');
    switch (initIdentifier) {
      case 'users_accessdenied':
        accessDeniedInit();
        break;
      case 'users_showlogin':
        showLoginInit();
        break;
    }
  });

  const googleLoginButton = document.getElementById('custom-google-signup-btn');
  const $githubLoginButton = $('#custom-github-signup-btn');
  if (googleLoginButton) {
    try {
      googleOAuthInit(googleLoginButton);
    } catch (e) {
      console.warn(e);
    }
  }
  if ($githubLoginButton) {
    githubOAuthInit($githubLoginButton);
  }
});

/**
 * Initialization for the access denied templates
 */
function accessDeniedInit() {
  $('.js-signin-url').attr('href', $('.js-signin-url').attr('href') + window.location.hash);
}

/**
*  Initialization for the showLogin template
*/
function showLoginInit() {
  $('.js-redirect-url').val($('.js-redirect-url').val() + window.location.hash);
}

/**
 * Initialization for Github OAuth button on login page.
 * @param {!jQuery} $githubLoginButton the GitHub Login Button element
 */
export function githubOAuthInit($githubLoginButton) {
  $githubLoginButton.click(e =>
    onGithubOAuth($('.js-github-authenticity-token').data('token')),
  );
}

